import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 168 154"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D9D9D9",
      d: "M168 .002 167.905 0a9.06 9.06 0 0 0-6.622 2.877l-126.441 136C29.488 144.636 33.578 154 41.447 154H0c3.668 0 7.166-1.545 9.633-4.255L133.784 13.382C138.463 8.242 134.811 0 127.856 0H168z"
    }, null, -1)
  ])))
}
export default { render: render }